import AddTemplate from "../_templates/AddTemplate";
import { umpireSchema } from "../../../schemas/umpire.schema";
import { createUmpire } from "../../../api/coredata.api";

export default function AddUmpire() {
  return (
    <AddTemplate
      title="Add Umpire"
      schema={umpireSchema}
      createFn={createUmpire}
      redirectPath="/cricket/umpires"
    />
  );
}
